import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

// MSAL renews tokens silently by loading redirectUri ('/') in a hidden iframe.
// Because redirectUri is the app root, bootstrapping again inside that iframe
// re-triggers acquireTokenSilent and makes MSAL throw block_iframe_reload.
// Skip bootstrap in the iframe; msal-browser 5.x only reads the iframe's auth response
// through the redirect bridge, so without it silent renewal times out (UC-AUTH-2).
if (window === window.parent) {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
} else {
  broadcastResponseToMainFrame().catch((err) => console.error(err));
}
